module.exports=[
  {
    "candidate": "Eric Brakey",
    "First ballot": .37,
    "Redistributed votes": .14
  },
  {
    "candidate": "Adrienne Bennett",
    "First ballot": .32,
    "Redistributed votes": .17
  }
]
